import request from '../utils/request';

/* APIs that accept time range type */

// (Reverted) services will trust caller to pass already-normalized params from timeSelection

//TotalCTA statistics
export const getCtaStatistics = async (params) => {
  return request('/cta/statistics', { method: 'get', params });
};

//TotalUsers statistics
export const getUsersStatistics = async (params) => {
  return request('/users/statistics', { method: 'get', params });
};

// TotalConversations statistics
export const getConversationStatistics = async (params) => {
  return request('/conversation/statistics', { method: 'get', params });
};

// Conversation Accuracy
export const getConversationAccuracy = async (params) => {
  return request('/stats/conversationAccuracy', { method: 'get', params });
};

export const getBrandRanking = async (params) => {
  return request('/stats/brandRanking', { method: 'get', params });
};

export const getUserActivityRanking = async (params) => {
  return request('/conversation/userActivityRanking', { method: 'get', params });
};


/*  API that accepts startDate, endDate, and granularity */

//line chart data for daily stats
export const getDailyStats = async (params) => {
  return request('/stats/daily', { method: 'get', params });
};

//line chart data for cumulative stats
export const getCumulativeStats = async (params) => {
  return request('/stats/cumulative', { method: 'get', params });
};

/* APIs that accept only startDate, endDate */

export const getCtaDistribution = async (params) => {
  console.log(params)
  const query = {};
  if (params?.type && params.type !== 'ALL') query.type = params.type;
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;

  const res = await request('/cta/distribution', { method: 'get', params: query });
  const raw = res?.data ?? res; // support either envelope or plain mapping
  let normalized;
  if (Array.isArray(raw)) {
    normalized = raw;
  } else {
    normalized = Object.entries(raw || {}).map(([level, count]) => ({ level, count }));
  }
  return { code: 200, data: normalized };
};

export const getCtaValidationStatus = async (params) => {
  const query = {};
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;
  const res = await request('/cta/validation-status', { method: 'get', params: query });
  const raw = res?.data ?? res;
  const arr = Array.isArray(raw) ? raw : Object.entries(raw || {}).map(([status, count]) => ({ status, count }));
  return { code: 200, data: arr };
};

export const getModelConsumption = async (params) => {
  const query = {};
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;
  const res = await request('/model/consumption', { method: 'get', params: query });
  const raw = res?.data ?? res;
  // Expected: { keys: string[], rows: Array<{ date: string, [modelName]: number }> }
  let keys = raw?.keys;
  let rows = raw?.rows;
  // Backward/fallback: derive from array-only responses if needed
  if (!Array.isArray(rows) && Array.isArray(raw)) {
    rows = raw;
  }
  if (!Array.isArray(keys) && Array.isArray(rows) && rows.length > 0) {
    const sample = rows[0] || {};
    keys = Object.keys(sample).filter((k) => k !== 'date');
  }
  return { code: 200, data: { keys: Array.isArray(keys) ? keys : [], rows: Array.isArray(rows) ? rows : [] } };
};

export const getUserActivityRate = async (params) => {
  const query = {};
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;
  const res = await request('/users/activity-rate', { method: 'get', params: query });
  // backend returns array; keep as-is but wrap for consistency
  const raw = res?.data ?? res;
  return { code: 200, data: Array.isArray(raw) ? raw : [] };
};

export const getUserSubmissionContent = async (params) => {
  const query = {};
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;
  const res = await request('/message/submission-content', { method: 'get', params: query });
  const raw = res?.data ?? res;
  const labelMap = { image: 'Image', eml: 'Email Attachment', text: 'Text' };
  const arr = Array.isArray(raw)
    ? raw
    : Object.entries(raw || {}).map(([k, v]) => ({ type: labelMap[k] || k, count: v }));
  return { code: 200, data: arr };
};

// CTA rank (for word cloud) - returns top N CTA names mapping
export const getCtaRank = async (params) => {
  const query = {
    limit: params?.limit ?? 20,
  };
  if (params?.start) query.start = params.start;
  if (params?.end) query.end = params.end;
  if (params?.companyId !== undefined) query.companyId=params.companyId;
  const res = await request('/cta/rank', { method: 'get', params: query });
  const raw = res?.data ?? res;
  const arr = Array.isArray(raw) ? raw : Object.entries(raw || {}).map(([text, value]) => ({ text, value }));
  return { code: 200, data: arr };
};


